var _a;
import { AwsUi } from '../../../../core/runtime/src';
import { Spinner } from '../../../spinner/src';
import { getAriaLabel } from './aria-label';
import { S3_RESOURCE_SELECTOR_ITEM_TYPES } from './s3-config';
var BYTES_BASE = 1024;
var BYTES_DECIMALS = 2;
var BYTES_SIZES = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
export var formatBytes = function (bytes) {
    if (bytes === 0) {
        return "0 " + BYTES_SIZES[0];
    }
    var i = Math.floor(Math.log(bytes) / Math.log(BYTES_BASE));
    return parseFloat((bytes / Math.pow(BYTES_BASE, i)).toFixed(BYTES_DECIMALS)) + ' ' + BYTES_SIZES[i];
};
export var defaultColumnDefinitions = (_a = {},
    _a[S3_RESOURCE_SELECTOR_ITEM_TYPES.BUCKETS] = function (i18nStrings, bucketNameCell) { return [
        {
            id: 'ID',
            header: function () { return i18nStrings.columnBucketID; },
            label: getAriaLabel(i18nStrings, 'ID'),
            cell: function (item) { return item.ID; }
        },
        {
            id: 'Name',
            header: function () { return i18nStrings.columnBucketName; },
            label: getAriaLabel(i18nStrings, 'Name'),
            cell: bucketNameCell,
            minWidth: '250px'
        },
        {
            id: 'CreationDate',
            header: function () { return i18nStrings.columnBucketCreationDate; },
            label: getAriaLabel(i18nStrings, 'CreationDate'),
            cell: function (item) { return item.CreationDate; }
        },
        {
            id: 'Region',
            header: function () { return i18nStrings.columnBucketRegion; },
            label: getAriaLabel(i18nStrings, 'Region'),
            cell: function (item) { return item.Region || AwsUi.__createElement(Spinner, null); },
            minWidth: '150px'
        },
        {
            id: 'Access',
            header: function () { return i18nStrings.columnBucketAccess; },
            label: getAriaLabel(i18nStrings, 'Access'),
            cell: function (item) { return item.Access || AwsUi.__createElement(Spinner, null); }
        }
    ]; },
    _a[S3_RESOURCE_SELECTOR_ITEM_TYPES.OBJECTS] = function (i18nStrings, objectKeyCell) { return [
        {
            id: 'ID',
            header: function () { return i18nStrings.columnObjectID; },
            label: getAriaLabel(i18nStrings, 'ID'),
            cell: function (item) { return item.ID; }
        },
        {
            id: 'Key',
            header: function () { return i18nStrings.columnObjectKey; },
            label: getAriaLabel(i18nStrings, 'Key'),
            cell: objectKeyCell,
            minWidth: '250px'
        },
        {
            id: 'LastModified',
            header: function () { return i18nStrings.columnObjectLastModified; },
            label: getAriaLabel(i18nStrings, 'LastModified'),
            cell: function (item) { return item.LastModified || '-'; }
        },
        {
            id: 'Size',
            header: function () { return i18nStrings.columnObjectSize; },
            label: getAriaLabel(i18nStrings, 'Size'),
            cell: function (item) { return (item.Size ? formatBytes(item.Size) : '-'); }
        }
    ]; },
    _a[S3_RESOURCE_SELECTOR_ITEM_TYPES.VERSIONS] = function (i18nStrings) { return [
        {
            id: 'ID',
            header: function () { return i18nStrings.columnVersionID; },
            label: getAriaLabel(i18nStrings, 'ID'),
            cell: function (item) { return item.ID; },
            minWidth: '250px'
        },
        {
            id: 'CreationDate',
            header: function () { return i18nStrings.columnVersionCreationDate; },
            label: getAriaLabel(i18nStrings, 'CreationDate'),
            cell: function (item) { return item.CreationDate; }
        },
        {
            id: 'Size',
            header: function () { return i18nStrings.columnVersionSize; },
            label: getAriaLabel(i18nStrings, 'Size'),
            cell: function (item) { return (item.Size ? formatBytes(item.Size) : '-'); }
        }
    ]; },
    _a);
//# sourceMappingURL=column-definitions.js.map